'use client';

import LoadingButton from '@/components/loadingButton/LoadingButton';
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from '@/components/ui/form';
import {Input} from '@/components/ui/input';
import {zodResolver} from '@hookform/resolvers/zod';
import {useState, useTransition} from 'react';
import {useForm} from 'react-hook-form';
import {z} from 'zod';

import {forgotPassword} from '@/app/(auth)/forgot-password/actions';
import ErrorMessage from '@/components/errorMessage/ErrorMessage';
const formSchema = z.object({
  email: z.string().email('Invalid email address'),
});

type FormData = z.infer<typeof formSchema>;

export default function ForgotPasswordForm() {
  const [loading, startTransition] = useTransition();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const form = useForm<FormData>({
    mode: 'onBlur',
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
    },
  });

  function handleOnSubmit(values: FormData) {
    setErrorMessage(null);

    startTransition(async () => {
      const {error} = await forgotPassword({
        ...values,
        redirectTo: '/reset-password',
      });
      if (error) {
        setErrorMessage(error);
      }
    });
  }

  function handleOnError() {
    setErrorMessage('Please correct the errors in the form');
  }

  return (
    <Form {...form}>
      <form
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={form.handleSubmit(handleOnSubmit, handleOnError)}
        className="flex flex-col gap-4"
      >
        <FormField
          control={form.control}
          name="email"
          render={({field}) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input autoComplete="email" type="email" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <ErrorMessage errorMessage={errorMessage} />
        <LoadingButton loading={loading} type="submit">
          Reset Password
        </LoadingButton>
      </form>
    </Form>
  );
}
